import React from 'react';

export default function ClimbersDealSupport() {
  const styles = {
    page: {
      backgroundColor: '#ffffff',
      minHeight: '100vh',
      fontFamily: 'Times, "Times New Roman", serif',
      color: '#000000',
      margin: 0,
      padding: 0,
    },
    container: {
      maxWidth: '8.5in',
      margin: '0 auto',
      padding: '1in',
      lineHeight: '1.5',
      fontSize: '12pt',
    },
    header: {
      textAlign: 'center',
      marginBottom: '30px',
      borderBottom: '2px solid #000',
      paddingBottom: '20px',
    },
    title: {
      fontSize: '18pt',
      fontWeight: 'bold',
      margin: '0 0 10px 0',
      textTransform: 'uppercase',
      letterSpacing: '1px',
    },
    subtitle: {
      fontSize: '14pt',
      fontWeight: 'normal',
      margin: '0',
      fontStyle: 'italic',
    },
    section: {
      marginBottom: '25px',
      pageBreakInside: 'avoid',
    },
    sectionNumber: {
      fontSize: '14pt',
      fontWeight: 'bold',
      marginBottom: '10px',
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
    },
    paragraph: {
      fontSize: '12pt',
      marginBottom: '12px',
      textAlign: 'justify',
      textIndent: '0.5in',
      lineHeight: '1.5',
    },
    paragraphNoIndent: {
      fontSize: '12pt',
      marginBottom: '12px',
      textAlign: 'justify',
      lineHeight: '1.5',
    },
    footer: {
      marginTop: '40px',
      paddingTop: '20px',
      borderTop: '1px solid #000',
      textAlign: 'center',
      fontSize: '10pt',
      color: '#666',
    },
  };

  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <div style={styles.header}>
          <h1 style={styles.title}>Climbers Deal – Support</h1>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionNumber}>Contact</h2>
          <p style={styles.paragraph}>
            please email: flowintothewall@gmail.com
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionNumber}>Policies</h2>
          <p style={styles.paragraphNoIndent}>
            <strong>Privacy Policy:</strong>{' '}
            https://www.funghokkeung.com/climbers-deal-privacy
          </p>
          <p style={styles.paragraphNoIndent}>
            <strong>Terms of Service:</strong>{' '}
            https://www.funghokkeung.com/climbers-deal-terms
          </p>
        </div>

        <div style={styles.footer}>
          <p>Document effective as of the date of last revision.</p>
        </div>
      </div>
    </div>
  );
}
